import React from 'react';
import Icon from '../../../components/AppIcon';

const ClientStats = ({ clients }) => {
  const totalClients = clients?.length;
  const activeClients = clients?.filter(client => client?.status === 'active')?.length;
  const adminClients = clients?.filter(client => client?.status === 'blocked')?.length;
  const developerClients = clients?.filter(client => client?.status === 'in_process')?.length;

  const stats = [
    {
      id: 'total',
      label: 'Total Clients',
      value: totalClients,
      icon: 'Users',
      color: 'text-primary bg-primary/10 border-primary/20',
      change: '',
      changeType: 'positive'
    },
    {
      id: 'active',
      label: 'Active',
      value: activeClients,
      icon: 'UserCheck',
      color: 'text-success bg-success/10 border-success/20',
      change: '',
      changeType: 'positive'
    },
    {
      id: 'admins',
      label: 'Inactive',
      value: adminClients,
      icon: 'Shield',
      color: 'text-warning bg-warning/10 border-warning/20',
      change: '',
      changeType: 'positive'
    },
    {
      id: 'developers',
      label: 'Inprocess',
      value: developerClients,
      icon: 'Code',
      color: 'text-accent bg-accent/10 border-accent/20',
      change: '',
      changeType: 'positive'
    }
  ];

  const getChangeIcon = (type) => {
    switch (type) {
      case 'positive':
        return 'TrendingUp';
      case 'negative':
        return 'TrendingDown';
      default:
        return 'Minus';
    }
  };

  const getChangeColor = (type) => {
    switch (type) {
      case 'positive':
        return 'text-success';
      case 'negative':
        return 'text-error';
      default:
        return 'text-muted-foreground';
    }
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {stats?.map((stat) => (
        <div
          key={stat?.id}
          className="bg-card border border-border rounded-lg p-6 hover:shadow-soft transition-shadow"
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center border ${stat?.color}`}>
              <Icon name={stat?.icon} size={24} />
            </div>
            <div className={`flex items-center space-x-1 text-sm ${getChangeColor(stat?.changeType)}`}>
              <Icon name={getChangeIcon(stat?.changeType)} size={14} />
              <span>{stat?.change}</span>
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-foreground mb-1">
              {stat?.value?.toLocaleString()}
            </h3>
            <p className="text-sm text-muted-foreground">
              {stat?.label}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ClientStats;